import { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';

export type RequestInterceptor = (config: AxiosRequestConfig)=> Promise<AxiosRequestConfig> | AxiosRequestConfig;
export type RequestErrorInterceptor = (err: AxiosError)=> Promise<any>;
export type ResponseInterceptor = (response: AxiosResponse)=> Promise<AxiosResponse> | AxiosResponse;
export type ResponseErrorInterceptor = (err: AxiosError)=> Promise<any>;

const identity = (param: any): any => param;

export default class Interceptor {
  request?: RequestInterceptor;
  requestError?: RequestErrorInterceptor;
  response?: ResponseInterceptor;
  responseError?: ResponseErrorInterceptor;

  constructor(interceptor: Interceptor) {
    this.request = !interceptor.request && interceptor.requestError ? identity : interceptor.request;
    this.requestError = interceptor.requestError;
    this.response = !interceptor.response && interceptor.responseError ? identity : interceptor.response;
    this.responseError = interceptor.responseError;
  }
}
